import React from 'react';
import Layout from '@common/layout';
import Content from '@common/content';
import { useTerms } from '@repository/terms/useTerms';
import Terms from '../../components/terms';

const PrivacyCollectionPage = () => {
  const { data } = useTerms({ termType: 'PROFILE_PRIVACY_COLLECTION' });

  if (!data) return null;
  return (
    <Layout>
      <Content>
        <Terms title={'개인정보 수집 및 이용 동의'} termsList={data} />
      </Content>
    </Layout>
  );
};

export default PrivacyCollectionPage;
